import { getFieldLabel } from "@/util/DataUtil";
export default {
  getHead: () => {
    return [
      { name: "설립별" },
      { name: "구분(급별)" },
      { name: getFieldLabel() },
      { name: "이름" }, // ??
      { name: "직종" },
      { name: "검진일" },
      { name: "이상소견" },
      { name: "작성자" },
    ];
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0:
        return func.getContent(value).inputA_10 ? func.getContent(value).inputA_10 : '-'; // 설립별
      case 1:
        return func.getContent(value).inputA_2; // 구분(급별)
      case 2:
        return func.getContent(value).inputA_3; // 학교(기관)명
      case 3:
        return func.getContent(value).inputA_8; // 이름
      case 4:
        return func.getContent(value).inputA_6; // 직종
      case 5:
        return func.getContent(value).inputB_1; // 검진일
      case 6:
        return func.getContent(value).inputB_2 === "있음" ? func.getContent(value).inputB_2_value : "없음"; // 이상소견
      case 7:
        return func.getContent(value).stdInfo.writer_name; // 작성자
      }
    } catch (e) {
      /*ignore*/
    }
    return "";
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.created_at) {
      nav.dateTarget = "created_at";
      nav.dateBegin = "nav.value.created_at.sDate";
      nav.dateEnd = "nav.value.created_at.eDate";
    }
    return { disasterType: nav.value.disasterType, searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword };
  },
  getSearchKeyword: (nav) => {
    const returnData = [];

    if (nav.value.disasterType) returnData.push("content$body.inputD_3*[:default_disaster]");

    switch (nav.value.searchType) {
    case "설립별":
      returnData.push("content$body.inputA_10*%[:default_skw]%");
      break;
    case "구분(급별)":
      returnData.push("content$body.inputA_2*%[:default_skw]%");
      break;
    case getFieldLabel():
      returnData.push("content$body.inputA_3*%[:default_skw]%");
      break;
    case "이름":
      returnData.push("content$body.inputA_8*%[:default_skw]%");
      break;
    case "직종":
      returnData.push("content$body.inputA_6*%[:default_skw]%");
      break;
    case "이상소견": {
      if (nav.value.searchKeyword === "없음") {
        returnData.push("content$body.inputB_2*%[:default_skw]%");
      } else {
        returnData.push("content$body.inputB_2_value*%[:default_skw]%");
      }
      break;
    }
    case "작성자":
      returnData.push("content$body.stdInfo.writer_name*%[:default_skw]%");
      break;
    }

    return returnData;
  },
};
